import { Autocomplete, CircularProgress, TextField, Typography, Chip } from '@mui/material';
import React, { useState } from 'react';

const ExpertSearchBar = ({
    open,
    handleOpen,
    handleClose,
    options,
    selectedExperts,
    setSelectedExperts,
    loading,
    handleAutocompleteInput
}: any) => {
    const [searchInput, setSearchInput] = useState('');

    const noOptionsText =
        options.length === 0 ? 'No Options' : 'No match found';

    return (
        <>
            <Typography
                sx={{
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    marginTop: 4,
                    fontWeight: 600,
                    lineHeight: '24px',
                    letterSpacing: '0px',
                    textAlign: 'left',
                    color: '#10383D',
                }}
            >
                Search and Select Experts
            </Typography>

            <Autocomplete
                multiple
                id="expert-search"
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                options={options || []}
                getOptionLabel={(option: any) => option.expert_details.email}
                value={selectedExperts}
                onChange={(event, newValue) => setSelectedExperts(newValue)}
                filterSelectedOptions
                inputValue={searchInput}
                onInputChange={(event, newInputValue) => {
                    setSearchInput(newInputValue);
                }}
                noOptionsText={noOptionsText}
                filterOptions={(opts) =>
                    opts.filter((option: any) =>
                        option.expert_details.email
                            ?.toLowerCase()
                            .includes(searchInput.toLowerCase())
                    )
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Search for experts..."
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        onChange={(e) => { handleAutocompleteInput(e) }}
                    />
                )}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            label={option.expert_details.email}
                            {...getTagProps({ index })}
                            sx={{
                                backgroundColor: '#E3F2FD',
                                color: '#10383D',
                                margin: '4px',
                            }}
                        />
                    ))
                }
            />
        </>
    );
};

export default ExpertSearchBar;
